import { QueryClient, VueQueryPlugin } from "@tanstack/vue-query";

export default ({ app }) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 2,
        staleTime: 1000 * 60 * 5, // 5 minutes
      },
    },
  });

  app.use(VueQueryPlugin, { queryClient });
};
